/** A commercial draft belongs to the actor who opened it, including across token refresh. */
import {getAuthHeaders, supabase} from '../utils/supabase/client';
export async function assertEventActor(actorId: string): Promise<void> {
  const {data,error} = await supabase.auth.getSession();
  if(error || !actorId || data.session?.user.id !== actorId) throw new Error('Your account changed. Reopen the event before continuing.');
}
export async function getEventActorHeaders(actorId: string, extra: Record<string,string> = {}): Promise<Record<string,string>> {
  await assertEventActor(actorId);
  const headers = await getAuthHeaders(extra);
  await assertEventActor(actorId);
  return headers;
}
